// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/basic-instrument-manoeuvres.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/basic-instrument-manoeuvres/basic-instrument-manoeuvres.js';

mount([g0]);
